<div class="flex w-full h-full">
  <div class="flex flex-col w-full">
    <div class="flex flex-row">
      <ng-container [ngSwitch]="pageLoadingState$ | async">
        <ng-container *ngSwitchCase="LoadingState.Pending">
          <div class="m-auto">
            <div class="flex h-full">
              <hospitable-loading></hospitable-loading>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="LoadingState.Success">
          <div class="flex flex-col w-full" *ngIf="exports$ | async as exports">
            <ng-container *ngIf="exports && exports.length > 0; else noData">
              <div class="relative overflow-x-auto rules__container">
                <table class="w-full text-sm text-left rtl:text-right text-gray-500 border-collapse">
                  <thead class="text-xs text-gray-700 border-b border-alt-gray-light">
                    <tr>
                      <th scope="col" class="px-6 py-3">Status</th>
                      <th scope="col" class="px-6 py-3">Type</th>
                      <th scope="col" class="px-6 py-3">Sent to</th>
                      <th scope="col" class="px-6 py-3">Created at</th>
                      <th scope="col" class="px-6 py-3">Filters</th>
                      <th scope="col" class="px-6 py-3"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let export of exports" class="bg-white border-b border-alt-gray-light">
                      <td scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                        <hospitable-badge
                          class="flex"
                          [type]="export.status === ExportStatus.Ready ? BadgeType.Success : BadgeType.Primary"
                          [size]="BadgeSize.XSmall"
                          [label]="export.status | titlecase"
                        ></hospitable-badge>
                      </td>
                      <td class="px-6 py-4">
                        {{ export.type | titlecase }}
                      </td>
                      <td class="px-6 py-4">
                        {{ export.email }}
                      </td>
                      <td class="px-6 py-4">
                        {{
                          export.sent_at
                            ? (export.sent_at | timeAgo)
                            : export.failed_at
                            ? (export.failed_at | timeAgo)
                            : export.created_at
                            ? (export.created_at | timeAgo)
                            : 'Just now'
                        }}
                      </td>
                      <td class="px-6 py-4">
                        <div class="grass-darker clickable" [satPopoverAnchor]="p" (mouseenter)="p.open()" (mouseleave)="p.close()">
                          {{ export.scope_for_tooltip.label }}
                        </div>

                        <sat-popover verticalAlign="below" horizontalAlign="start" #p>
                          <div class="popover" *ngIf="export && export.scope_for_tooltip && export.scope_for_tooltip.filters">
                            <div style="margin-bottom: 12px">
                              <strong>Type</strong>
                              <span>{{ export.type | titlecase }}</span>
                            </div>

                            <div *ngFor="let filter of export.scope_for_tooltip.filters | keyvalue">
                              <strong style="vertical-align: top">{{ filter.value.label }}</strong>

                              <div style="display: inline-block" *ngIf="filter.value && filter.value.values">
                                <p *ngFor="let value of filter.value.values">
                                  {{ value === 'Include unlisted' ? 'Yes' : value }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </sat-popover>
                      </td>
                      <td class="px-6 py-4">
                        <div *ngIf="export.file_name" class="flex clickable" (click)="downloadExport(export.uuid, export.file_name)">
                          <svg height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 1V10.6" stroke="#47C693" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                              d="M6.3999 7L9.9999 10.6L13.5999 7"
                              stroke="#47C693"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M19 10.6V11.8C19 12.4365 18.7471 13.0469 18.2971 13.497C17.847 13.9471 17.2365 14.2 16.6 14.2H3.4C2.76348 14.2 2.15303 13.9471 1.70294 13.497C1.25286 13.0469 1 12.4365 1 11.8V10.6"
                              stroke="#47C693"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <ng-container *ngIf="pagination$ | async as pagination">
                <hospitable-pagination [pagination]="pagination" (pageChanged)="onPageChange($event)"></hospitable-pagination>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="LoadingState.Error">
          <div class="m-auto">
            <div class="flex h-full">
              <hospitable-page-level-error> </hospitable-page-level-error>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #noData>
  <div class="flex items-center justify-center mt-8">
    <hospitable-page-level-error message="No data exported yet. Visit another tab and hit 'Export' to get started."> </hospitable-page-level-error>
  </div>
</ng-template>
